import { defineMessages } from 'react-intl';

const commonMessages = defineMessages({
  approve: {
    defaultMessage: 'Approve',
  },
  back: {
    defaultMessage: 'Back',
  },
  cancel: {
    defaultMessage: 'Cancel',
  },
  close: {
    defaultMessage: 'Close',
  },
  closeDialog: {
    defaultMessage: 'Close dialog',
  },
  comingSoon: {
    defaultMessage: 'Coming Soon',
  },
  continue: {
    defaultMessage: 'Continue',
  },
  delete: {
    defaultMessage: 'Delete',
  },
  emDash: {
    defaultMessage: '—',
  },
  goPlanName: {
    defaultMessage: 'Go',
  },
  gotIt: {
    defaultMessage: 'Got it',
  },
  growPlanName: {
    defaultMessage: 'Grow',
  },
  growUnlimitedPlanName: {
    defaultMessage: 'Grow Unlimited',
  },
  learnMore: {
    defaultMessage: 'Learn more',
  },
  loading: {
    defaultMessage: 'Loading…',
  },
  logout: {
    defaultMessage: 'Logout',
  },
  new: {
    defaultMessage: 'New',
  },
  none: {
    defaultMessage: 'None',
  },
  okay: {
    defaultMessage: 'Okay',
  },
  or: {
    defaultMessage: 'or',
  },
  other: {
    defaultMessage: 'Other',
  },
  reject: {
    defaultMessage: 'Reject',
  },
  save: {
    defaultMessage: 'Save',
  },
  showLess: {
    defaultMessage: 'Show less',
  },
  showMore: {
    defaultMessage: 'Show more',
  },
  skipForNow: {
    defaultMessage: 'Skip for now',
  },
  subtotal: {
    defaultMessage: 'Subtotal',
  },
  tryAgain: {
    defaultMessage: 'Try again',
  },
  typeToSearch: {
    defaultMessage: 'Type to search',
  },
  unlimited: {
    defaultMessage: 'Unlimited',
  },
});

export default commonMessages;
